function hexToHsl(hex) {
  // Remove # if present
  hex = hex.replace(/^#/, "");

  // Parse r, g, b
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  // Convert RGB [0,255] → [0,1]
  const rNorm = r / 255;
  const gNorm = g / 255;
  const bNorm = b / 255;

  const max = Math.max(rNorm, gNorm, bNorm);
  const min = Math.min(rNorm, gNorm, bNorm);
  let h, s, l;

  l = (max + min) / 2;

  if (max === min) {
    // achromatic
    h = s = 0;
  }
  else {
    const d = max - min;

    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case rNorm:
        h = ((gNorm - bNorm) / d + (gNorm < bNorm ? 6 : 0)); 
        break;
      case gNorm:
        h = ((bNorm - rNorm) / d + 2); 
        break;
      case bNorm:
        h = ((rNorm - gNorm) / d + 4); 
        break;
    }

    h *= 60;
  }

  return {
    h: Math.round(h),
    s: Math.round(s * 100),
    l: Math.round(l * 100)
  };
}

function hslToHex({h, s, l}) {
  // Convert to [0,1] range
  s /= 100;
  l /= 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const hp = h / 60;
  const x = c * (1 - Math.abs(hp % 2 - 1));

  let r1, g1, b1;
  if (hp >= 0 && hp < 1) [r1, g1, b1] = [c, x, 0];
  else if (hp < 2)       [r1, g1, b1] = [x, c, 0];
  else if (hp < 3)       [r1, g1, b1] = [0, c, x];
  else if (hp < 4)       [r1, g1, b1] = [0, x, c];
  else if (hp < 5)       [r1, g1, b1] = [x, 0, c];
  else                   [r1, g1, b1] = [c, 0, x];

  const m = l - c / 2;
  const r = Math.round((r1 + m) * 255);
  const g = Math.round((g1 + m) * 255);
  const b = Math.round((b1 + m) * 255);

  return "#" + 
    r.toString(16).padStart(2, "0") +
    g.toString(16).padStart(2, "0") +
    b.toString(16).padStart(2, "0");
}

function adjustNeonL(hsl) {
  const { h } = hsl;

  // Neon-prone hue ranges
  const neonHue =
    (h >= 60 && h <= 140) ||     // yellow → lime → green
    (h >= 140 && h <= 170);      // greenish-cyan

  if (neonHue) {
    // Reduce lightness by 20%, but keep it above 20
    hsl.l = Math.max(20, hsl.l * 0.8);
  }

  return hsl;
}


// Given a list of { h, s, l } colors, return a new color { h, s, l } that is maximally distant by hue.
export function generateColor(existingColors) {
  let h = 230, s = 100, l = 35;

  if (existingColors.length == 0)
    return hslToHex({ h, s, l });

  let hslColors = existingColors.map(hexRgb => hexToHsl(hexRgb));
  hslColors.sort((a, b) => a.h - b.h);

  if (hslColors.length == 1)
    return hslToHex({ h: (hslColors[0].h + 180) % 360, s, l });

  let mostDistantPair = null;
  for (let i = 0; i < hslColors.length; i++) {
    let c1 = hslColors[i];
    let c2 = hslColors[(i + 1) % hslColors.length];
    let dist = Math.abs((c2.h - c1.h + 360) % 360);
    if (mostDistantPair == null || dist > mostDistantPair.dist)
      mostDistantPair = { c1, c2, dist };
  }

  let { c1, c2, dist } = mostDistantPair;
  let color = hslToHex({ h: (c1.h + dist / 2) % 360, s, l });
  color = adjustNeonL(color);
  return color;
}